import axios from "axios";
import { RegisterFormData, RegisterFormResponse } from "./types";
import { ENDPOINTS } from "@/core/api/apiClient";
import apiClient from "@/core/api/apiClient";

export const submitRegistrationForm = async (
  formData: RegisterFormData
): Promise<RegisterFormResponse> => {
  try {
    // Calculate age for validation (should be 21+)
    const birthDate = new Date(formData.birthDate);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age < 21) {
      return {
        success: false,
        message: "You must be 21 or older to register.",
      };
    }

    // Only send fields expected by the backend
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      password: formData.password,
      phone: formData.phone,
      birthDate: formData.birthDate,
      eventUpdates: formData.eventUpdates,
      promoOffers: formData.promoOffers,
      textMessages: formData.textMessages,
      isEmployee: false, // Always false for new users
    };

    const response = await apiClient.post(
      ENDPOINTS.SEND_REGISTRATION_FORM,
      payload
    );

    if (response.status === 201 || response.status === 200) {
      return {
        success: true,
        message: "Your account has been created successfully.",
      };
    } else {
      return {
        success: false,
        message: "There was an error creating your account. Please try again.",
      };
    }
  } catch (error: any) {
    console.error("Registration submission error:", error);

    if (axios.isAxiosError(error) && error.response) {
      if (error.response.status === 409) {
        return {
          success: false,
          message: "An account with this email already exists.",
        };
      } else if (error.response.status === 400) {
        return {
          success: false,
          message: "Please check your information and try again.",
        };
      }
    }

    return {
      success: false,
      message:
        "We're experiencing technical difficulties. Please try again later.",
    };
  }
};
